import React, { Component, useEffect, useState } from 'react';
import * as d3 from "d3";

function Knowledge (props) {

    const knowledge = props.knowledge,
        setKnowledge = props.setKnowledge

    useEffect(() => {
    })

    return (
        <div className="general_field">
            <legend>How would you describe your <strong>knowledge about gender issues</strong>?</legend>
            <div className="general_options">
                <label>
                    <input 
                        type="radio" 
                        name="knowledge" 
                        value="5" 
                        checked={knowledge === "5"}
                        onChange={() => setKnowledge("5")}
                    />
                        Expert
                </label>
                <label>
                    <input 
                        type="radio" 
                        name="knowledge" 
                        value="4" 
                        checked={knowledge === "4"}
                        onChange={() => setKnowledge("4")}
                    />
                    Advanced
                </label>
                <label>
                    <input 
                        type="radio" 
                        name="knowledge" 
                        value="3" 
                        checked={knowledge === "3"}
                        onChange={() => setKnowledge("3")}
                    />
                    Good
                </label>
                <label>
                    <input 
                        type="radio" 
                        name="knowledge" 
                        value="2"
                        checked={knowledge === "2"}
                        onChange={() => setKnowledge("2")}
                    />
                    Moderate
                </label>
                <label>
                    <input 
                        type="radio" 
                        name="knowledge" 
                        value="1"
                        checked={knowledge === "1"}
                        onChange={() => setKnowledge("1")}
                    />
                    Limitate
                </label>
                <label style={{marginTop: '0.2em'}}>
                    <input 
                        type="radio" 
                        name="knowledge" 
                        value="no_answer"
                        checked={knowledge === "no_answer"}
                        onChange={() => setKnowledge("no_answer")}
                        />
                    I prefer not to answer.
                </label>
            </div>
        </div>
    )
}

export default Knowledge;